//  学习班类型相关 api
import request from '@/api/request'

// 获取修改页面数据
export function saveApi(datas:any){
    let url = '/api/manager/t-supplement-score/save';
    let data = {
        "datas":datas
    }
    return request({
        url: url,
        method: 'post',
        data
    })
}

